import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { Apartments, Building } from "./data-contracts";

export const getAppApartmentsIndex = (
  building: number,
  query?: {
    limit?: number;
    offset?: number;
    filter?: string[];
  },
  params?: IFetchConfig,
) =>
  fetch<{
    data: Apartments[];
    total: number;
  }>("GET", `building/${building}/apartments`, query, params);

export const getAppApartmentsShow = (building: number, apartment: number, params?: IFetchConfig) =>
  fetch<Apartments>("GET", `building/${building}/apartment/${apartment}`, null, params);

export const getAppBuildingShowList = (params?: IFetchConfig) =>
  fetch<
    {
      id: number;
      address: string;
      city: string;
      residential_complex: string;
      is_annual_calculation: boolean;
      is_archived: boolean;
      only_for_reports: boolean;
      company_id: number;
      company_name: string;
      cloning_readings: boolean;
    }[]
  >("GET", `building/short_list`, null, params);

export const getAppBuildingIndex = (
  query: {
    limit?: number;
    offset?: number;
    filter?: string[];
    month_period: string;
    year_period: string;
  },
  params?: IFetchConfig,
) =>
  fetch<{
    data: Building[];
    total: number;
  }>("GET", `building/`, query, params);

export const postAppBuildingNew = (
  data: {
    street?: string;
    number?: string;
    city?: number;
    distributorType?: number;
    isAnnualCollection?: boolean;
    periodStart?: string;
    periodEnd?: string;
    constantConsumptionCoef?: number;
    variableConsumptionCoef?: number;
    minCoverageArea?: number;
    flatTariff?: number;
    apartmentTariff?: number;
    commercialTariff?: number;
    residentialComplex?: number;
    company?: number;
    onlyForReports?: boolean;
    cloningReadings?: boolean;
    onlyLastDayOfMonthReadings?: boolean;
  },
  params?: IFetchConfig,
) => fetch<void>("POST", `building/new`, data, params);

export const getAppBuildingShow = (id: number, params?: IFetchConfig) =>
  fetch<Building>("GET", `building/${id}`, null, params);

export const deleteAppBuildingDelete = (id: number, params?: IFetchConfig) =>
  fetch<{
    message?: string;
  }>("DELETE", `building/${id}`, null, params);

export const putAppBuildingEdit = (
  id: number,
  data: {
    street?: string;
    number?: string;
    city?: number;
    distributorType?: number;
    isAnnualCollection?: boolean;
    periodStart?: string;
    periodEnd?: string;
    constantConsumptionCoef?: number;
    variableConsumptionCoef?: number;
    minCoverageArea?: number;
    flatTariff?: number;
    apartmentTariff?: number;
    commercialTariff?: number;
    residentialComplex?: number;
    company?: number;
    onlyForReports?: boolean;
    cloningReadings?: boolean;
    onlyLastDayOfMonthReadings?: boolean;
  },
  params?: IFetchConfig,
) => fetch<void>("PUT", `building/${id}/edit`, data, params);

export const getAppBuildingApartmentsInfo = (
  id: number,
  query?: {
    limit?: number;
    offset?: number;
    working_distributors_count?: number;
    filter?: string[];
  },
  params?: IFetchConfig,
) =>
  fetch<{
    apartments_count: number;
    total_area: number;
    calculate_by_area_count: number;
  }>("GET", `building/${id}/apartments_info`, query, params);

export const getAppPercentageCalcApartments = (
  id: number,
  query: {
    limit?: number;
    offset?: number;
    filter?: string[];
    period_start: string;
    period_end: string;
  },
  params?: IFetchConfig,
) =>
  fetch<
    {
      date: string;
      /** @format float */
      percent: number;
      closed: boolean;
      /** @format float */
      percent_all: number;
    }[]
  >("GET", `building/${id}/percentage_calc_apartments`, query, params);

export const postAppBuildingAddToArchive = (id: number, params?: IFetchConfig) =>
  fetch<Building>("POST", `building/${id}/add_to_archive`, null, params);

export const getAppApartmentsTypesByBuilding = (id: number, params?: IFetchConfig) =>
  fetch<
    {
      apartment_type_id: number;
    }[]
  >("GET", `building/${id}/apartments_types`, null, params);

export const getAppBuildingReadings = (
  building: number,
  query: {
    period_start: string;
    period_end: string;
    apartments_type?: number;
    limit?: number;
    offset?: number;
    filter?: string[];
  },
  params?: IFetchConfig,
) =>
  fetch<{
    data: {
      apartment_id: number;
      apartment_number: string;
      distributor_number: string;
      apartment_area: string;
      apartment_coefficient_id: number;
      apartment_coefficient: string;
      power_coefficient: string;
      distributor_start_readings: string;
      apartment_type_id: number;
      apartment_type: string;
      distributor_id: number;
      distributor_archiving_date: string;
      data: {
        /** @format float */
        readings?: number;
        /** @format float */
        consumption?: number;
        period?: string;
        type?: {
          id?: number;
          description?: string;
        };
      }[];
    }[];
    total: number;
  }>("GET", `building/${building}/readings`, query, params);
